module.exports = __webpack_public_path__ + "static/media/catalogueImg5.880048a9.png";